import { isBrowser } from './WebApi';
import { needsAppNexusSync, parsePulseCookies, serializePulseCookie } from './pulse-cookie';
function pixelUrl(userServiceLocation) {
    const url = new URL('/api/v1/sync?ANID=$UID', userServiceLocation).toString();
    return `https://secure.adnxs.com/getuid?${url}`;
}
const APP_NEXUS_SYNC_URL = 'https://secure.adnxs.com/getuidj';
const PIXEL_ID = 'pulse2an_36jayge7acx2ge456aau2ls4tpa0z';
function insertAppNexusPixel(cisLocation) {
    if (!isBrowser) {
        return false;
    }
    const preExitingPixel = document.getElementById(PIXEL_ID);
    if (!preExitingPixel) {
        const img = document.createElement('img');
        img.src = pixelUrl(cisLocation);
        img.id = PIXEL_ID;
        img.style.display = 'none';
        const body = document.getElementsByTagName('body').item(0);
        body.appendChild(img);
        return true;
    }
    return false;
}
let currentRequest = Promise.resolve(false);
/**
 * Do a sync with AppNexus.
 * @returns whether a new sync with CIS is required.
 */
export function serialAppNexusSync() {
    currentRequest = currentRequest.then(() => fetch(APP_NEXUS_SYNC_URL, {
        method: 'GET',
        credentials: 'include',
    })
        .then((response) => response.json())
        .then(({ uid } = {}) => {
        if (uid) {
            const existingCookie = parsePulseCookies();
            if (uid !== existingCookie.anId) {
                const updatedCookie = { ...existingCookie, anId: uid };
                serializePulseCookie(updatedCookie);
                return true;
            }
        }
        return false;
    })
        // we don't take any action when the request fails. No cis sync is required.
        .catch(() => false));
    return currentRequest;
}
/**
 * The boolean value of the returned Promise indicates of the sync with AppNexus
 * requires an extra sync with CIS.
 */
export default async function appNexusSync(cisLocation = 'https://cis.schibsted.com') {
    const parsedCookie = parsePulseCookies();
    if (needsAppNexusSync(parsedCookie)) {
        const pixelInserted = insertAppNexusPixel(cisLocation);
        if (pixelInserted) {
            await new Promise((resolve) => {
                setTimeout(() => resolve(true), 2000);
            });
            return serialAppNexusSync();
        }
        return false;
    }
    return false;
}
//# sourceMappingURL=appNexus.js.map